const LUNCH_TZ = 'America/Sao_Paulo';

/**
 * HH:mm de um instante ISO/Date em America/Sao_Paulo (pt-BR).
 * @param {string|Date|null|undefined} isoOrDate
 * @returns {string|null}
 */
export function formatLunchTimeSaoPaulo(isoOrDate) {
  if (isoOrDate == null || isoOrDate === '') return null;
  const d = isoOrDate instanceof Date ? isoOrDate : new Date(isoOrDate);
  if (Number.isNaN(d.getTime())) return null;
  try {
    return new Intl.DateTimeFormat('pt-BR', {
      timeZone: LUNCH_TZ,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(d);
  } catch {
    return null;
  }
}

/**
 * Texto do tooltip de almoço no Board.
 * @param {string|Date|null|undefined} startedAtIso
 * @returns {string}
 */
export function formatLunchSinceTooltip(startedAtIso) {
  const hhmm = formatLunchTimeSaoPaulo(startedAtIso);
  if (!hhmm) return 'Em horário de almoço';
  return `Em horário de almoço desde ${hhmm}`;
}
